import { render, staticRenderFns } from "./classroomInfo.vue?vue&type=template&id=0338bab8&scoped=true&"
import script from "./classroomInfo.vue?vue&type=script&lang=js&"
export * from "./classroomInfo.vue?vue&type=script&lang=js&"
import style0 from "./classroomInfo.vue?vue&type=style&index=0&id=0338bab8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0338bab8",
  null
  
)

export default component.exports